import { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

const RankingSelector = ({ ranking, rankings, competicion }) => {
  const navigate = useNavigate();
  const { rankingId: paramRankingId } = useParams();

  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const [pill, setPill] = useState({ left: 0, width: 0, height: 0 });

  // ID activo derivado: usa el de props/URL y si no existe, cae al primero
  const activeId = useMemo(() => {
    if (ranking?.id) return String(ranking.id);
    if (paramRankingId) return String(paramRankingId);
    if (rankings?.length) return String(rankings[0].id);
    return null;
  }, [ranking, paramRankingId, rankings]);

  // Si no hay ranking válido en URL/props, redirigimos al primero cuando todo esté listo
  useEffect(() => {
    if (!competicion?.id) return;
    if (!rankings || rankings.length === 0) return;

    const firstId = String(rankings[0].id);

    // si no hay param o el param no existe en la lista, redirige al primero
    const exists = rankings.some(r => String(r.id) === String(paramRankingId));
    if (!paramRankingId || !exists) {
      navigate(`/competicion/${competicion.id}/ranking/${firstId}`, { replace: true });
    }
  }, [competicion?.id, rankings, paramRankingId, navigate]);

  // índice del activo (si no se encuentra, 0)
  const activeIdx = useMemo(() => {
    if (!rankings || !rankings.length || !activeId) return 0;
    const idx = rankings.findIndex(r => String(r.id) === String(activeId));
    return idx >= 0 ? idx : 0;
  }, [rankings, activeId]);

  // recolocar la “píldora” cuando cambie el activo o al hacer resize
  useEffect(() => {
    const update = () => {
      const container = containerRef.current;
      const item = itemRefs.current[activeIdx];
      if (!container || !item) return;
      const c = container.getBoundingClientRect();
      const b = item.getBoundingClientRect();
      setPill({ left: b.left - c.left, width: b.width, height: b.height });
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [activeIdx, rankings]);

  if (!rankings || !competicion) return null;

  return (
    <div className="flex justify-center mb-4">
      <div
        ref={containerRef}
        className="relative flex items-center gap-3 rounded-xl ring-1 ring-white/10 px-2 py-1"
      >
        {/* píldora roja */}
        <span
          aria-hidden
          className="absolute rounded-md bg-ccnorte transition-all duration-300 ease-out"
          style={{ left: pill.left, width: pill.width, height: pill.height }}
        />
        {/* items */}
        {rankings.map((r, index) => (
          <Link
            key={r.id}
            ref={el => (itemRefs.current[index] = el)}
            to={`/competicion/${competicion.id}/ranking/${r.id}`}
            className={[
              'relative z-10 px-5 py-2 rounded-md font-montserrat text-xs uppercase tracking-wide',
              'cursor-pointer transition-colors duration-200',
              String(activeId) === String(r.id) ? 'text-white' : 'text-white hover:text-gray-400',
            ].join(' ')}
          >
            {r.nombre}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RankingSelector;
